export default __webpack_public_path__ + "locales/sq-AL/Files.json?hash=c34ea508317b645ebb79f4aee74fdd0d";